module.exports = __webpack_public_path__ + "media/svg/comment-71d76738.svg";